import { useApi } from '@/api';
import { ChartSkeleton, ChartTimeFilter } from '@/components';
import { useMemo, useState, useCallback } from 'react';
import {
  formatCurrency,
  LineChart,
  Flex,
  formatDatetime
} from '@blockanalitica/ui';
import { useChartPeriod } from '@/hooks';

export default function HistoricGraphs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi({
    url: `/farms/historic/`,
    queryParams: {
      days_ago: chartDaysAgo,
      what: 'staked'
    }
  });

  if (error) {
    throw error;
  }

  const [chartPeriod, updateChartConfigWithPeriod] =
    useChartPeriod(chartDaysAgo);
  const subValueFormatter = useCallback(
    (value: string) => (
      <>
        {chartPeriod.labelPrefix}
        {formatDatetime(value, { format: chartPeriod.dateFormat })}
      </>
    ),
    [chartPeriod]
  );
  const config = updateChartConfigWithPeriod();
  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <LineChart
          key="Total Value Locked"
          data={data}
          datasets={[
            {
              xField: 'date',
              yField: 'tvl'
            }
          ]}
          timeFilter={timeFilter}
          yScaleValueFormatter={(value: number) => formatCurrency(value)}
          valueFormatter={(value: number) => formatCurrency(value)}
          config={config}
          subValueFormatter={subValueFormatter}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
